let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6uXxs")).then(() => parcelRequire('8RV1B'));